import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Pagination from "../../../shared/general/Pagination";
import "../Evaluation/IndividualPlanEvaluation.css";
import EmployeeInfo from "../../../shared/pages/okrs/components/EmployeeInfo";
import ShowMiniData from "../../../shared/pages/okrs/components/ShowMiniData";
import { Data } from "../mockData";
import { styled } from "@mui/styles";
import { useSelector, useDispatch } from "react-redux";
import { getAllIdvPlan } from "../../../../../actions/IndividualPlans";

import {
  Grid,
  InputAdornment,
  TextField,
  Toolbar,
  Typography,
  Avatar,
  Button,
  IconButton,
  LinearProgress,
  Container,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import SearchIcon from "@mui/icons-material/Search";
import EventIcon from "@mui/icons-material/Event";
import VpnKeyRoundedIcon from "@mui/icons-material/VpnKeyRounded";
import FlagIcon from "@mui/icons-material/Flag";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiGrid-container": {
      marginBottom: "0 !important",
    },
    "& .MuiCardContent-root": {
      padding: 0,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 16,
    },
  },
  imageEmp: {
    width: 160,
    height: 160,
    borderRadius: "50%",
  },
  viewBtn: {
    backgroundColor: "#4f65df",
    color: "#fff",
    borderRadius: "50px",
    fontSize: "12px",
    "&:hover": {
      backgroundColor: "#4f65df",
    },
  },
  quater: {
    backgroundColor: "#e53935",
    fontWeight: "600",
    width: 48,
    height: 48,
  },
  PlanList_Object: {
    fontSize: "1.3rem",
    fontWeight: "600",
    color: "#222f3e",
  },
  PlanList_Impact: {
    color: "#9e9e9e",
    marginTop: 8,
    
  },
  PlanList_KR: {
    color: "#222f3e",
    fontSize: "1.1rem",
    fontWeight: "700",
  },
  PlanList_Status: {
    display: "flex",
    alignItems: "center",
    color: "#9e9e9e",
    marginBottom: 8,
  },
  PlanList_dateCreate: {
    color: "#9e9e9e",
  },
  employeeInfo: {
    
  },
  waiting: {
    backgroundColor: "#eeeeee",
    color: "#9e9e9e",
    minWidth: "100px",
    borderRadius: "15px",
    padding: "5px 10px 5px 10px",
    textAlign: "center",
    marginLeft: 8,
    "&:hover": {
      backgroundColor: "#eeeeee",
    },
  },
  viewBtn: {
    cursor: "pointer",
    backgroundColor: "#e6eaff",
    color: "#4f65df",
    width: 40,
    height: 40,
    marginRight: 8,
  },
  cardList_KR: {
    backgroundColor: "#ffebee",
    color: "#f44336",
  },
}));

const ContainerStyled = styled(Container)({
  marginTop: "100px",
});

function EmployeePlanList() {
  const history = useHistory();
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const { result: idvPlanStore } = useSelector((state) => state.IdvPlans);

  const [planList, setPlanList] = useState([]);
  const [planItems, setPlanItems] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(2);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = planList.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const fetchData = () => {
    dispatch(getAllIdvPlan());
  };

  useEffect(() => {
    if (idvPlanStore) {
      let plans = idvPlanStore.filter(function (item) {
        return (
          item.createByEmpId === location.state.employee.createByEmpId &&
          item.planStatus === "Waiting Approval"
        );
      });

      setPlanList(plans);
      setPlanItems(plans);
      setIsLoading(false);
    }
  }, [idvPlanStore]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    let x = [...planItems];
    x = x.filter((y) => {
      return y.objectiveName
        .toLowerCase()
        .includes(searchKey.toLocaleLowerCase());
    });
    setPlanList(x);
  }, [searchKey]);

  return (
    <ContainerStyled>
      <div className="card-section">
        <div className="header-section">
          <Grid container>
            <Grid item>
              <h3 className="header-topic">Individual Planning List</h3>
            </Grid>
          </Grid>
        </div>
        {location.state.employee && (
          <EmployeeInfo idEmployees={location.state.employee.createByEmpId} />
        )}
        <Toolbar>
          <Grid container justifyContent="flex-end">
            <Grid item xs={12} md={4} lg={4}>
              <TextField
                variant="outlined"
                style={{ width: "100%" }}
                label="Search Objective"
                value={searchKey}
                onChange={(e) => setSearchKey(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment>
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </div>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <div>
          {planList.length > 0 &&
            planList.map((item) => {
              return (
                <>
                  <Typography variant="h6" className="keyResult">
                    <FlagIcon fontSize="large" className="svgKey" />
                    Objective
                  </Typography>
                  <div key={item.planIdvId} className="cardPlan_Objective">
                    <Grid
                      container
                      alignItems="flex-start"
                      alignContent="space-between"
                    >
                      <Grid item xs={3} sm={2} md={1} lg={1} xl={1}>
                        <Avatar className={classes.quater}>
                          {item.quater}
                        </Avatar>
                      </Grid>
                      <Grid item xs={7} sm={7} md={8} lg={8} xl={8}>
                        <Typography
                          className={classes.PlanList_Object}
                          gutterBottom
                        >
                          {item.objectiveName}
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={2}
                        sm={3}
                        md={3}
                        lg={3}
                        xl={3}
                        justifyContent="flex-end"
                      >
                        <Avatar
                          className={classes.viewBtn}
                          onClick={() => {
                            history.push({
                              pathname: `/individualplanevaluation/${item.planIdvId}`,
                              state: { planList: item },
                            });
                          }}
                        >
                          <SearchIcon />
                        </Avatar>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={2} sm={2} md={1} lg={1} xl={1}></Grid>
                      <Grid item xs={10} sm={10} md={8} lg={8} xl={8}>
                        <Typography className={classes.PlanList_Status}>
                          {item.impactName}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={2} sm={2} md={1} lg={1} xl={1}></Grid>
                      <Grid item xs={10} sm={10} md={8} lg={8} xl={8}>
                        <ShowMiniData
                          date={item.dateCreate}
                          status={item.planStatus}
                          progress=""
                        />
                      </Grid>
                    </Grid>
                  </div>
                  <Typography variant="h6" className="keyResult">
                    <VpnKeyRoundedIcon fontSize="large" className="svgKey" />
                    Key Result
                  </Typography>
                  {item.keyResult1 && (
                    <div className="cardPlan">
                      <Grid container alignItems="center">
                        <Grid item xs={2} md={1} lg={1} xl={1} sm={2}>
                          <Avatar className={classes.cardList_KR}>
                            <KeyboardArrowRightIcon />
                          </Avatar>
                        </Grid>
                        <Grid item xs={10} md={11} lg={11} xl={11} sm={10}>
                          <Typography className={classes.PlanList_KR}>
                            {item.keyResult1}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                  {item.keyResult2 && (
                    <div className="cardPlan">
                      <Grid container alignItems="center">
                        <Grid xs={2} md={1} lg={1} xl={1} sm={2}>
                          <Avatar className={classes.cardList_KR}>
                            <KeyboardArrowRightIcon />
                          </Avatar>
                        </Grid>
                        <Grid item xs={10} md={11} lg={11} xl={11} sm={10}>
                          <Typography className={classes.PlanList_KR}>
                            {item.keyResult2}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                  {item.keyResult3 && (
                    <div className="cardPlan" style={{ marginBottom: "30px" }}>
                      <Grid container alignItems="center">
                        <Grid item xs={2} md={1} lg={1} xl={1} sm={2}>
                          <Avatar className={classes.cardList_KR}>
                            <KeyboardArrowRightIcon />
                          </Avatar>
                        </Grid>
                        <Grid item xs={10} md={11} lg={11} xl={11} sm={10}>
                          <Typography className={classes.PlanList_KR}>
                            {item.keyResult3}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                </>
              );
            })}
        </div>
      )}
      <Pagination
        paginate={paginate}
        postsPerPage={postsPerPage}
        // planList
        totalPosts={Data.length}
      />
    </ContainerStyled>
  );
}

export default EmployeePlanList;
